module.exports = __webpack_public_path__ + "static/media/covid-19-logo.13e98aee.png";